export default __webpack_public_path__ + "static/media/excel.d066dcb3.png";